import React from 'react';
import ExpandableSection from '../../../../../components/ExpandableSection';

interface AdditionalInfo {
    type: string;
    description?: string;
}

interface AdditionalInfoProps {
    additionalInfo: AdditionalInfo[];
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
const AdditionalInfo: React.FC<AdditionalInfoProps> = ({ additionalInfo }) => {
    if (!additionalInfo?.length) return null;

    const midPoint = Math.ceil(additionalInfo.length / 2);
    const firstColumn = additionalInfo.slice(0, midPoint);
    const secondColumn = additionalInfo.slice(midPoint);

    return (
        <ExpandableSection title="Información adicional" defaultExpanded={true}>
            <div className='additional-info'>
                <ul style={{ padding: '0 1rem', flex: 1 }}>
                    {firstColumn.map((info, index) => (
                        <li key={index} style={{ padding: '0.5rem 0' }}>
                            {info.description || info.type}
                        </li>
                    ))}
                </ul>
                <ul style={{ padding: '0 1rem', flex: 1 }}>
                    {secondColumn.map((info, index) => (
                        <li key={index} style={{ padding: '0.5rem 0' }}>
                            {info.description || info.type}
                        </li>
                    ))}
                </ul>
            </div>
        </ExpandableSection>
    );
};

export default AdditionalInfo;